<template>
  <v-card outlined max-width="380">
    <v-card-subtitle class="pb-0"> 監修者 </v-card-subtitle>
    <div>
      <v-card-text class="pt-0">
        <v-combobox
          v-model="expert"
          :items="selectableExperts"
          item-text="name"
          item-value="id"
          hide-selected
          chips
          :disabled="mode == 'readonly'"
          deletable-chips
        />
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'ExpertableField',
  data () {
    return {
      rejectId: [],
      selectableExperts: []
    }
  },
  computed: {
    ...mapState({
      mode: (state) => state.PostEditor.mode
    }),
    expert: {
      get () {
        return this.$store.state.PostEditor.post.expertable
      },
      set (expert) {
        return this.$store.commit('PostEditor/UPDATE_EXPERTABLE', expert)
      }
    }
  },
  mounted: function () {
    const expertsRequest = axios.get('/api/experts')
    const adminusersRequest = axios.get('/api/admin_users')
    axios
      .all([expertsRequest, adminusersRequest])
      .then(
        axios.spread((...responses) => {
          responses[0].data.data.forEach(({ attributes }) => {
            attributes = Object.assign(attributes, { type: 'Expert' })
            this.selectableExperts.push(attributes)
          })
          responses[1].data.data.forEach(({ attributes }) => {
            attributes = Object.assign(attributes, { type: 'User' })
            this.selectableExperts.push(attributes)
          })
        })
      )
      .catch((error) => console.error(error))
  }
}
</script>

<style scoped></style>
